
import magazineContribute from './magazineContribute/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('key', {
  magazineContribute
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/emojis/reducer.js
 **/